import { Grid, SxProps, Theme, Typography } from '@mui/material';

import { SystemStyleObject } from '@mui/system';

import ErrorIcon from 'assets/icons/new/selection/error.svg';

import { styles } from './styles';

export const Error = ({ message, sx }: { message?: string | null; sx?: SxProps<Theme> }) => {
  return (
    <Grid sx={[styles.container, sx as SystemStyleObject<Theme>]}>
      <ErrorIcon />
      <Typography>{message || 'Something went wrong, please try again!'}</Typography>
    </Grid>
  );
};
